export default __webpack_public_path__ + "static/media/icon-pen-circle-outline.f5c41461.svg";